<template>
  <div class="wrapper">
    <Menu />
    <div class="body-area">
      <div class="container-fluid">
        <div class="slider-box position-relative row" style="z-index: 99">
          <div
            class="header-area position-absolute w-100 bg-transparent border-0 fc-5"
            style="z-index: 9"
          >
            <div class="container-fluid">
              <div class="row">
                <div class="col-6">
                  <a href="#">
                    <span class="back-arrow mt-4"></span>
                  </a>
                </div>
                <div class="col-6 text-right">
                  <a href="#"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-left: -15px; margin-right: -15px; position: relative">
          <img src="https://anadoluefessk.org/assets/img/header-kss.jpg" class style="width: 100%;" />
          <h1
            class="fs-32 fc-5 slider-title position-absolute"
            style="z-index: 9999;
    bottom: 20px;
    left: 20px;"
          >
            Sosyal Sorumluluk
            Projeleri
          </h1>
        </div>
        <div class="row">

          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-header p-0">
                <carousel :perPage="1" @pageChange="pageChange" :paginationEnabled="true" :paginationSize="8" :paginationPadding="3">
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_01.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_02.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_03.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_04.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_05.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_06.jpg" style="width:100%" />
                    </div>
                  </slide>
                </carousel>
                
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Pembe Top Sahada</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü, her sezon Euroleague’de oynadığı ilk iç saha maçında, “Meme Kanseri Farkındalık Ayı” kapsamında Anadolu Sağlık Merkezi iş birliğiyle “Pembe Top Sahada” projesini gerçekleştirmektedir. Altı kez düzenlenen proje kapsamında Pembe Top maçlarının hava atışı, projenin gönüllü destekçileri Beren Saat, Bergüzar Korel, Sinem Kobal, Elçin Sangu, Özge Özpirinçci ve Bensu Soral tarafından pembe top ile gerçekleştirilmiştir.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-header p-0">
                <carousel :perPage="1" @pageChange="pageChange" :paginationEnabled="true" :paginationSize="8" :paginationPadding="3">
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/bir_kitap_sen_getir_01.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/bir_kitap_sen_getir_02.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/bir_kitap_sen_getir_03.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/bir_kitap_sen_getir_04.jpg" style="width:100%" />
                    </div>
                    </slide>
                </carousel>
                
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Bir Kitap da Sen Getir</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü tarafından 2015 yılından bu yana düzenli bir şekilde gerçekleştirilen Bir Kitap da Sen Getir projesi, her yıl Kütüphaneler Haftası’nda düzenlenmektedir. Basketbolseverler, kampanya kapsamında seçilen maç için bilet almak yerine kitap getirerek salona giriş yapabilmektedir. Her yıl kampanya çerçevesinde basketbolseverlerden toplanan binlerce kitap, Anadolu Eğitim ve Sosyal Yardımlaşma Vakfı desteğiyle ihtiyaç sahibi okullara ulaştırılmaktadır. Anadolu Efes, Bir Kitap da Sen Getir Kampanyası’nı beşinci kez Basketbol Süper Ligi’ndeki Anadolu Efes – Bahçeşehir Koleji maçında gerçekleştirmiştir.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-header p-0">
                <carousel :perPage="1" @pageChange="pageChange" :paginationEnabled="true" :paginationSize="8" :paginationPadding="3">
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/one_team_2015_02.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/one_team_2016_02.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/one_team_2018_01.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/one_team_2019_02.jpg" style="width:100%" />
                    </div>
                    </slide>
                </carousel>
                
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">EuroLeague One Team Projeleri</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Euroleague’in, Turkish Airlines EuroLeague ve EuroCup organizasyonlarına katılan 40 takımı entegre ettiği bir kurumsal sosyal sorumluluk programı olan One Team’de basketbol, toplumda gerçek bir sosyal etki elde etmek için bir araç olarak kullanılmaktadır. One Team programında “toplumsal entegrasyon” teması altında çalışmalar yapılmaktadır. Her kulüp kendi topluluğunun ihtiyaçlarına yönelik özel bir One Team projesi geliştirmektedir.</p>
                    <h4>2019-2020 Beylikdüzü Belediyesi One Team Projesi:</h4>
                    <p style="text-align:justify">2018-2019 sezonundaki proje, Beylikdüzü Belediyesi’yle birlikte devam ettirilerek, katılımcıların edindikleri faydanın sürekli hale getirilmesi amaçlanmıştır.</p>
                    <br />
                    <h4>2018-2019 Özel Olimpiyatlar Türkiye One Team Projesi:</h4>
                    <p style="text-align:justify">Bu projede hem Özel Olimpiyatlar Türkiye hem de Beylikdüzü Belediyesi ile birlikte yaptığımız iş birliği ile down sendromlu özel sporcuların kişisel gelişimlerine katkıda bulunulması amaçlanmıştır.</p>
                    <br />
                    <h4>2017-2018 Sezonu Okyanus Kolejleri One Team Projesi:</h4>
                    <p style="text-align:justify">Projenin amacı, hızla gelişen teknolojinin hayatımızı kolaylaştırırken bir yandan da fiziksel olarak bizleri yavaşlattığı gerçeğini kabul ederek, çocuklara spor yapma alışkanlığı kazandırmaktı.</p>
                    <br />
                    <h4>2016-2017 Sezonu Anadolu Etap-MİÇO (Misafir İşçi Çocukları) One Team Projesi:</h4>
                    <p style="text-align:justify">Projenin amacı, yaz tatillerinde aileleri ile birlikte Anadolu Etap’ın çiftliklerine gelen mevsimlik işçi çocuklarının basketbol ile tanıştırılması ve bu sayede sosyalleşmeleriydi.</p>
                    <br />
                    <h4>2016-2017 Sezonu Koruncuk Vakfı One Team Projesi:</h4>
                    <p style="text-align:justify">Projenin temel amacı, korunma altına alınmış çocukların kaybolmuş özgüvenlerini basketbolun metaforları ile geri kazandırmak ve geleceğe umutla bakan bireyler haline getirmekti.</p>
                    <br />
                    <h4>2015-2016 Sezonu Tozkoparan Ortaokulu One Team projesi:</h4>
                    <p style="text-align:justify">Projenin temel amacı, erken okul terkine karşı basketbolun metaforları ile çocuklara okul sevgisi kazandırmak ve geleceğe umutla bakmalarını sağlamaktı.</p>
                    <br />
                    <h4>2014-2015 Sezonu: Özel Sporcular Abdi İpekçi’de:</h4>
                    <p style="text-align:justify">Euroleague’in sosyal sorumluluk programı “One Team” kapsamında Anadolu Efes - Sassari karşılaşması öncesinde Özel Olimpiyatlar sporcuları seyircileri selamladı. Zihinsel engelli çocukların topluma kazandırılmasını amaçlayan Özel Olimpiyatlar Hareketi’nin sporcuları Anadolu Efes ve Sassari takım oyuncuları ile birlikte sahaya girerek basketbolcu ağabeyleri ile birlikte fotoğraf çektirdi.</p>
                    <br />
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü, 2016 – 2017 sezonunda Anadolu Etap ve Koruncuk Vakfı, 2017-2018 sezonunda da Okyanus Kolejleri ile birlikte gerçekleştirdiği projelerle Euroleague tarafından “One Team Ödülü”ne aday gösterilmiş ve son 5 takım arasına kalmıştır.</p>
                    <br />
                    <p style="text-align:justify">2018-2019 sezonunda Özel Olimpiyatlar Türkiye ile gerçekleştirilen proje ise EuroLeague ve EuroCup’ta yer alan 40’tan fazla kulübün projeleri arasından en iyi seçilerek EuroLeague Altın Ödülü’ne layık görülmüştür. Böylece altın ödül, ilk kez bir Türk kulübü tarafından kazanılmıştır.</p>
                    <br />
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü’nün 2019 – 2020 sezonunda gerçekleştirdiği One Team projesi de EuroLeague tarafından One Team Ödülleri’nde finale kalan projeler arasında gösterilmiştir.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-header p-0">
                <carousel :perPage="1" @pageChange="pageChange" :paginationEnabled="true" :paginationSize="8" :paginationPadding="3">
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/okyanus_koleji_01.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/okyanus_koleji_02.jpg" style="width:100%" />
                    </div>
                    </slide>
                </carousel>
                
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Spor ile Eğitim Aynı Platformda</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü ile Okyanus Koleji arasında gerçekleştirilen iş birliği kapsamında, Anadolu Efes altyapısında oynayan sporcular, evlerine yakın okullarda eğitim alarak ulaşım stresi ve zaman kaybı yaşamayacak. Böylece altyapı oyuncuları, hem eğitim hayatlarına hem de basketbola daha kolay konsantre olabilecekler. Anadolu Efes Spor Kulübü altyapı takımlarında forma giyen 80’e yakın oyuncu, şu an Okyanus Koleji kampüslerinde eğitim hayatına devam ediyor.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-header p-0">
                <carousel :perPage="1" @pageChange="pageChange" :paginationEnabled="true" :paginationSize="8" :paginationPadding="3">
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/zalgiris_deplasman_01.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/zalgiris_deplasman_02.jpg" style="width:100%" />
                    </div>
                    </slide>
                </carousel>
                
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Down Sendromlu Gençlerin Litvanya’ya Götürülmesi</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü, Zalgiris Kaunas ve Special Olympics’in destekleriyle “21 Mart Dünya Down Sendromu Günü kapsamında Down Sendromu Derneği’nden iki genci Zalgiris Kaunas deplasmanına götürdü. Takım uçağında Litvanya’ya seyahat eden gençler, Special Olympics Litvanya bünyesindeki altı Litvanyalı sporcu ile birlikte karşılaşmanın devre arasında seyircileri selamladı. Ayrıca Şule İnan ve Robert Cem Osborn, devre arasında Litvanyalı sporcular ile yaptıkları basketbol yarışmasında da binlerce seyircinin önünde basket attı. Tüm taraftarlar down sendromlu gençleri ve sporcuları ayakta alkışladı. Bu proje ile birlikte oluşan sinerji sonrasında Anadolu Efes Spor Kulübü ve Zalgiris Kaunas kardeş kulüp oldular.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-header p-0">
                <carousel :perPage="1" @pageChange="pageChange" :paginationEnabled="true" :paginationSize="8" :paginationPadding="3">
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/bilecikli_sporcular_01.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/bilecikli_sporcular_02.jpg" style="width:100%" />
                    </div>
                    </slide>
                </carousel>
                
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Olympiacos karşılaşmasında Bilecikli genç basketbolcuları ağırladık</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Türk basketbolunda ilklerin öncüsü Anadolu Efes Spor Kulübü, Bilecik Bozüyük Mehmet Akif Ersoy Ortaokulu’nun kız basketbolcularına unutulmaz bir gün yaşattı. Gerçekleştirdiği sosyal sorumluluk projelerinde basketbol sevgisinin daha geniş kitlelere ulaşmasını sağlayan Anadolu Efes, Adana Vakıfbank Ortaokulu’yla karşı karşıya geldikleri maçta aldıkları farklı mağlubiyet sonrasında fazlasıyla üzülen ve kamuoyunun dikkatini çeken kız basketbolcuları, Olympiacos karşılaşmasında ağırladı. Genç basketbolcular, karşılaşma öncesinde Anadolu Efes’in başarılı oyuncuları kaptan Doğuş Balbay ve Cedi Osman’la tanışırken maç öncesinde Anadolu Efes oyuncuları için bir çıkış koridoru da oluşturdular. Ayrıca genç basketbolcuların Abdi İpekçi Spor Salonu’nda oldukları anons edildiğinde, tüm basketbolseverler Bilecikli konukları ayakta alkışladılar.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-header p-0">
                <carousel :perPage="1" @pageChange="pageChange" :paginationEnabled="true" :paginationSize="8" :paginationPadding="3">
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/bremen_mizikacilari_01.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/bremen_mizikacilari_02.jpg" style="width:100%" />
                    </div>
                    </slide>
                </carousel>
                
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Bremen Mızıkacıları Abdi İpekçi’de</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü’nün Turkish Airlines Euroleague Top 16 E Grubu’nun 11. haftasında Hırvatistan temsilcisi Cedevita Zagreb’i ağırladığı karşılaşmanın devre arasında zihinsel engelli çocuklardan oluşan Bremen Mızıkacıları Perküsyon Grubu, mini bir konser verdi. Karşılaşmanın devre arasında benzersiz bir performans sergileyen Bremen Mızıkacıları Perküsyon Grubu, basketbolseverler tarafından dakikalarca ayakta alkışlandı.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-header p-0">
                <carousel :perPage="1" @pageChange="pageChange" :paginationEnabled="false" :paginationSize="8" :paginationPadding="3">
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/gaziler_macta.jpg" style="width:100%" />
                    </div>
                    </slide>
                </carousel>
                
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Gazilerin Euroleague Maçında Ağırlanması</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü’nün Turkish Airlines Euroleague Top 16 E Grubu’nun 11. haftasında Hırvatistan temsilcisi Cedevita Zagreb’i ağırladığı karşılaşmanın devre arasında zihinsel engelli çocuklardan oluşan Bremen Mızıkacıları Perküsyon Grubu, mini bir konser verdi. Karşılaşmanın devre arasında benzersiz bir performans sergileyen Bremen Mızıkacıları Perküsyon Grubu, basketbolseverler tarafından dakikalarca ayakta alkışlandı.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-header p-0">
                <carousel :perPage="1" @pageChange="pageChange" :paginationEnabled="true" :paginationSize="8" :paginationPadding="3">
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/gorme_engellilere_mac_01.jpg" style="width:100%" />
                    </div>
                    </slide>
                    <slide>
                    <div class="fixture-item">
                      <img src="https://anadoluefessk.org/assets/img/kss/600x400/gorme_engellilere_mac_02.jpg" style="width:100%" />
                    </div>
                    </slide>
                </carousel>
                
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Görme Engellilere Canlı Maç Anlatımı</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü’nün Turkish Airlines Euroleague Top 16 E Grubu’nun 11. haftasında Hırvatistan temsilcisi Cedevita Zagreb’i ağırladığı karşılaşmanın devre arasında zihinsel engelli çocuklardan oluşan Bremen Mızıkacıları Perküsyon Grubu, mini bir konser verdi. Karşılaşmanın devre arasında benzersiz bir performans sergileyen Bremen Mızıkacıları Perküsyon Grubu, basketbolseverler tarafından dakikalarca ayakta alkışlandı.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Darülaceze Ziyareti</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes’in yıldız oyuncuları Doğuş Balbay, Birkan Batuk ve Stratos Perperoglou, kulübün resmi sponsoru Sarar ile birlikte Darülaceze’yi ziyaret etti. Ziyaret, toplumda yardıma ihtiyacı olan kişilere dikkat çekmek ve sivil toplum kuruluşlarını gündeme taşıyarak toplumsal bilincin oluşmasını desteklemek amacıyla gerçekleştirildi.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Darülaceze Ziyareti</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes’in yıldız oyuncuları Doğuş Balbay, Birkan Batuk ve Stratos Perperoglou, kulübün resmi sponsoru Sarar ile birlikte Darülaceze’yi ziyaret etti. Ziyaret, toplumda yardıma ihtiyacı olan kişilere dikkat çekmek ve sivil toplum kuruluşlarını gündeme taşıyarak toplumsal bilincin oluşmasını desteklemek amacıyla gerçekleştirildi.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Doğudan Batıya Minik Yürekler</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Doğu bölgelerimizde yaşayan öğrencilerin Anadolu Efes’in bir Euroleague maçına davet edilerek İstanbul’da ağırlandı. Akvaryum, Forum İstanbul vb yerlerde gezdirilmesi ve küçük bir İstanbul gezisi organize edildi.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Mavi Buluşmalar</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü oyuncuları, Tohum Otizm Vakfı’nı ziyaret etti. Ziyaret sonrasında vakıf bünyesindeki bireyler Euroleague maçında ağırlandı.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Basketbol Topu Kumbarası Kampanyası</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü’nün 35. kuruluş yılı etkinlikleri kapsamında Herkes için Spor Federasyonu desteğiyle yapılan kampanyada, Anadolu Efes Spor Kulübü’nün 35. yılındaki resmi maçlarda attığı basket sayısı kadar top, Düzce’de bulunan 12 ortaokula bağışlandı.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">35. Yıl Etkinlikleri</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">35. yıl etkinlikleri kapsamında Siirt Mehmet Akif Ersoy İlköğretim Okulu’na basketbol sahası yapılırken, Kastamonu ve Aksaray’da da basketbol sahaları yapıldı.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Zihinsel Engelli Çocukları Ziyaret</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">İstanbul Ümraniye’deki bir merkezde bulunan zihinsel engelli çocuklar ziyaret edildi.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Böbrek Vakfı Ziyareti</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü oyuncuları, Böbrek Vakfı Hastanesi’nde tedavi gören vatandaşlarımızı ziyaret ettiler.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Hakkari’de Basketbol Başkadır</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Hakkari’de bir edebiyat öğretmeni tarafından kurulan basketbol takımının en büyük hayalleri olan Abdi İpekçi Arena’da maç seyretme hayalleri gerçekleştirildi. Kızlı –erkekli 15 kişilik takım Hakkari’den İstanbul’a davet edilerek hem Abdi İpekçi Arena’da sahaya çıktılar, hem Anadolu Efes Basketbol Takımı ile tanıştılar hem de 2 gün süresince İstanbul’u gezme fırsatı elde ettiler.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">Efes ile İlk Adım Basketbol Okulları</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Edirne’den Hakkari’ye Kıbrıs’tan Giresun’a 42 farklı merkezde 9 yılda yaklaşık 22 bin çocuğa ücretsiz basketbol eğitimi verildi. Sadece çocuklara değil, aynı zamanda görevli teknik kadroya da eğitim programları düzenleyen “Efes ile İlk Adım Basketbol Okulları”, Anadolu Efes Spor Kulübü’nün uzman eğitmen kadrosu ve Gençlik ve Spor Genel Müdürlüğü’nün altyapı desteği ile Türkiye’de basketbol sporunu küçük yaştan başlayarak sevdirmeyi ve imkanı olmayan çocukların basketbol oynamalarını sağlamayı hedefledi.</p>
                    <p style="text-align:justify">Efes İle İlk Adım projesi kapsamında basketbol ve eğlencenin buluştuğu “Anadolu Efes İğneada Kampları” ile sporun ve basketbolun felsefesini ve faydalarını anlatmak amacıyla Efes ile İlk Adım Panelleri düzenlendi.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 p-0">
            <div class="item-box">
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">30.Yıl Etkinlikleri-Efes Akademi</h1>
                <div class="row">
                  <div class="col-12">
                    <p style="text-align:justify">Anadolu Efes Spor Kulübü’nün 30.yılında genç takım oyuncularının sosyal beceri ve motivasyon kazanması için “Efes Akademi” programı gerçekleştirildi. Sporcuların hem sosyal, hem profesyonel hayatta kişisel gelişimlerini sağlamayı hedefleyen Anadolu Efes, “Efes Akademi” programı ile bir ilke daha imza attı.</p>
                    <p style="text-align:justify">Anadolu Efes’in genç oyuncuları için düzenlediği “Efes Akademi” ile daha iyi basketbol oynamanın yanı sıra danstan sofra adabına her türlü centilmenlik kurallarını öğretilmesi hedeflendi. Hafta içi beş gün, toplam 12 saat süren “Efes Akademi” programında yer alan dersler; diksiyon, güzel ve etkili konuşma, yaratıcı drama, İngilizce, sporcu beslenmesi, spor psikolojisi, spor sakatlıkları ve ilk yardım, doping, spor gazeteciliği, ritimdans ve satranç oldu.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          


        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
export default {
  name: "SosyalSorumlulukProjeleri",
  components: {
    Footer,
    Menu,
    Header
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/SosyalSorumlulukProjeleri.vue